import { ApiResponse } from '../types/ApiResponse';

export const throwIfRequestError = (response: ApiResponse<unknown>, message?: string) => {
  if (Array.isArray(response.errors) && response.errors.length) {
    // TODO: not that we use 'em much yet, but deal with multiple errors in array
    throw Error(`${message} - ${JSON.stringify(response.errors[0])}`);
  }
};
